import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    DetailsItemEmpty,
    HeadingRaceDetails,
    HeadingRaceDetailsWrapper,
    RaceSummaryRowDetailsWrapper,
    HeadingRaceDetailsComment,
    DetailsTable,
    TheadCellWrapper,
    TheadWrapper,
    TheadCellFirst,
    TheadCell,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/RaceDetails/RaceDetails.style';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { RowItem } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/RaceDetails/RowItem/RowItem';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface RowDetailsPropsType {
    selectionId: SelectionId;
    isNonRunner?: boolean;
}

export const RowDetails = observer('RowDetails', ({ selectionId, isNonRunner }: RowDetailsPropsType) => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const runnerComment = selectionModel.metaDataRunnerComment;
    const racingFormDetails = selectionModel.computedRacingFormDetails ?? [];

    return (
        <RaceSummaryRowDetailsWrapper
            variant={configState.componentVariants.sportsbookVariant}
            isNonRunner={isNonRunner}
        >
            <HeadingRaceDetailsWrapper>
                <HeadingRaceDetails data-test='last-run-header'>Last Run:</HeadingRaceDetails>
                <HeadingRaceDetailsComment>{runnerComment}</HeadingRaceDetailsComment>
            </HeadingRaceDetailsWrapper>

            {racingFormDetails.length > 0 ? (
                <DetailsTable>
                    <TheadWrapper variant={configState.componentVariants.sportsbookVariant}>
                        <TheadCellFirst>Result</TheadCellFirst>
                        <TheadCellWrapper>
                            <TheadCell>Racecourse</TheadCell>
                            <TheadCell>Summary</TheadCell>
                        </TheadCellWrapper>
                    </TheadWrapper>
                    {racingFormDetails.map((detail, idx) => (
                        <RowItem
                            key={idx}
                            detail={detail}
                        />
                    ))}
                </DetailsTable>
            ) : (
                <DetailsItemEmpty>No racing form details available.</DetailsItemEmpty>
            )}
        </RaceSummaryRowDetailsWrapper>
    );
});
